import { FC } from "react";
import { RaffleProgress } from "entities/wheel-raffle";
import type { Raffle } from "entities/wheel-raffle";
import { JoinRaffleForm } from "features/join-wheel-raffle";
import { GiftIcon } from "shared/ui/icons";

import styles from "./RaffleDetailPage.module.css";

interface Props {
  raffle: Raffle;
  isDrawn: boolean;
  inviteCode: string | null;
}

const getResultText = (raffle: Raffle): string => {
  if (raffle.my_prize_usdt) return `You won ${raffle.my_prize_usdt} USDT!`;
  if (raffle.is_participant) return "You took part but didn't win this time.";
  return "This promo has been drawn.";
};

export const ParticipantPanel: FC<Props> = ({
  raffle,
  isDrawn,
  inviteCode,
}) => {
  if (isDrawn) {
    const isWinner = Boolean(raffle.my_prize_usdt);
    return (
      <p className={`${styles.result} ${isWinner ? styles.won : ""}`}>
        {isWinner && (
          <GiftIcon fill="currentColor" width={20} height={20} aria-hidden />
        )}
        {getResultText(raffle)}
      </p>
    );
  }

  const needsJoin = raffle.visibility === "private" && !raffle.has_joined;

  return (
    <>
      {needsJoin && (
        <JoinRaffleForm raffleId={raffle.id} initialCode={inviteCode} />
      )}
      <RaffleProgress raffle={raffle} />
    </>
  );
};
